<div class="dropdown ihost-dropdown h-100">
    <a class="dropdown-toggle btn-dots no-caret" href="#" role="button" data-bs-toggle="dropdown"
        data-bs-display="static" aria-expanded="false">
        <i class="icon-dots"></i>
    </a>
    <div class="dropdown-menu p-0 border-0 shadow-none">
        <a *ngFor="let action of actions" class="btn btn-sm py-1 px-2"
            [ngClass]="{ 'btn-remove': action.color == 'danger', 'btn-transparent-outline': action.color == 'default'}"
            (click)="action.action(context)">{{ action.name }}</a>
    </div>
</div>